import ApiClient from '@/api/settings/axios';

const apiClient = new ApiClient();

const requestLoginUser = ({ csrfToken, postParams }) => {
  const result = apiClient.post(
    '/user/login',
    { csrfToken, postParams },
  ).then(
    (res) => res,
  ).catch(
    (err) => err,
  );
  return result;
};

const requestLogOutUser = () => {
  const result = apiClient.get(
    '/user/logout',
  ).then(
    (res) => res,
  ).catch(
    (err) => err,
  );
  return result;
};

const requestCurrentUser = () => {
  const result = apiClient.get(
    '/user/point',
  ).then(
    (res) => res,
  ).catch(
    (err) => err,
  );
  return result;
};

const requestBuyPoint = ({ csrfToken, postParams }) => {
  const result = apiClient.post(
    '/user/point/buy',
    { csrfToken, postParams },
  ).then(
    (res) => res,
  ).catch(
    (err) => err,
  );
  return result;
};

const requestPointAppend = ({ csrfToken, postParams }) => {
  const result = apiClient.post(
    '/user/point/append',
    { csrfToken, postParams },
  ).then(
    (res) => res,
  ).catch(
    (err) => err,
  );
  return result;
};

const requestPointEnd = () => {
  const result = apiClient.get(
    '/user/point/end',
  ).then(
    (res) => res,
  ).catch(
    (err) => err,
  );
  return result;
};

const requestConfirmNotice = () => {
  const result = apiClient.get(
    '/user/notice/confirm_notice',
  ).then(
    (res) => res,
  ).catch(
    (err) => err,
  );
  return result;
};

const requestUserDetail = () => {
  const result = apiClient.get(
    '/user/detail',
  ).then(
    (res) => res,
  ).catch(
    (err) => err,
  );
  return result;
};

const requestChangeUserInformation = ({ csrfToken, postParams }) => {
  const result = apiClient.post(
    '/user/change',
    { csrfToken, postParams },
  ).then(
    (res) => res,
  ).catch(
    (err) => err,
  );
  return result;
};

const requestChangeUserPassword = ({ csrfToken, postParams }) => {
  const result = apiClient.post(
    '/user/change_password',
    { csrfToken, postParams },
  ).then(
    (res) => res,
  ).catch(
    (err) => err,
  );
  return result;
};

const requestConfirmUser = ({ csrfToken, postParams }) => {
  const result = apiClient.post(
    '/user/confirm',
    { csrfToken, postParams },
  ).then(
    (res) => res,
  ).catch(
    (err) => err,
  );
  return result;
};

const requestChangeUserAddress = ({ csrfToken, postParams }) => {
  const result = apiClient.post(
    '/user/append_address',
    { csrfToken, postParams },
  ).then(
    (res) => res,
  ).catch(
    (err) => err,
  );
  return result;
};

const requestGoogleLogin = ({ csrfToken, postParams }) => {
  const result = apiClient.post(
    '/user/google/login',
    { csrfToken, postParams },
  ).then(
    (res) => res,
  ).catch(
    (err) => err,
  );
  return result;
};

const requestGoogleCreate = ({ csrfToken, postParams }) => {
  const result = apiClient.post(
    '/user/google/create',
    { csrfToken, postParams },
  ).then(
    (res) => res,
  ).catch(
    (err) => err,
  );
  return result;
};

const requestAppendUser = ({ csrfToken, postParams }) => {
  const result = apiClient.post(
    '/user/append',
    { csrfToken, postParams },
  ).then(
    (res) => res,
  ).catch(
    (err) => err,
  );
  return result;
};

const requestReissuePassword = ({ csrfToken, postParams }) => {
  const result = apiClient.post(
    '/user/reset_password',
    { csrfToken, postParams },
  ).then(
    (res) => res,
  ).catch(
    (err) => err,
  );
  return result;
};

const requestReissuePasswordOneTime = ({ csrfToken, postParams }) => {
  const result = apiClient.post(
    '/user/create_onetime_reset_password',
    { csrfToken, postParams },
  ).then(
    (res) => res,
  ).catch(
    (err) => err,
  );
  return result;
};

const requestBuyRank = ({ csrfToken, postParams }) => {
  const result = apiClient.post(
    '/user/buy_rank',
    { csrfToken, postParams },
  ).then(
    (res) => res,
  ).catch(
    (err) => err,
  );
  return result;
};

const requestHasRegister = () => {
  const result = apiClient.get(
    '/user/has_register',
  ).then(
    (res) => res,
  ).catch(
    (err) => err,
  );
  return result;
};

const requestSetReferralCode = ({ csrfToken, postParams }) => {
  const result = apiClient.post(
    '/user/set_referral_code',
    { csrfToken, postParams },
  ).then(
    (res) => res,
  ).catch(
    (err) => err,
  );
  return result;
};

const requestDeleteIsUserRegister = () => {
  const result = apiClient.get(
    '/user/delete_is_user_register',
  ).then(
    (res) => res,
  ).catch(
    (err) => err,
  );
  return result;
};

const requestChangeCountry = ({ csrfToken, postParams }) => {
  const result = apiClient.post(
    '/user/change_country',
    { csrfToken, postParams },
  ).then(
    (res) => res,
  ).catch(
    (err) => err,
  );
  return result;
};

const requestChangeLanguage = ({ csrfToken, postParams }) => {
  const result = apiClient.post(
    '/user/change_language',
    { csrfToken, postParams },
  ).then(
    (res) => res,
  ).catch(
    (err) => err,
  );
  return result;
};

const requestSavedCard = ({ csrfToken, postParams }) => {
  const result = apiClient.post(
    '/user/point/savedcard',
    { csrfToken, postParams },
  ).then(
    (res) => res,
  ).catch(
    (err) => err,
  );
  return result;
};

const requestDeleteCard = ({ csrfToken, postParams }) => {
  const result = apiClient.post(
    '/user/point/deletecard',
    { csrfToken, postParams },
  ).then(
    (res) => res,
  ).catch(
    (err) => err,
  );
  return result;
};

const requestPointSavedCard = () => {
  const result = apiClient.get(
    '/user/point/savedcard',
  ).then(
    (res) => res,
  ).catch(
    (err) => err,
  );
  return result;
};

const requestPaypalCreateOrder = ({ csrfToken, postParams }) => {
  const result = apiClient.post(
    '/user/paypal/create_order',
    { csrfToken, postParams },
  ).then(
    (res) => res,
  ).catch(
    (err) => err,
  );
  return result;
};

const requestPaypalCaptureOrder = ({ csrfToken, postParams }) => {
  const result = apiClient.post(
    '/user/paypal/capture_order',
    { csrfToken, postParams },
  ).then(
    (res) => res,
  ).catch(
    (err) => err,
  );
  return result;
};

export {
  requestLoginUser,
  requestLogOutUser,
  requestCurrentUser,
  requestBuyPoint,
  requestPointAppend,
  requestConfirmNotice,
  requestPointEnd,
  requestUserDetail,
  requestChangeUserInformation,
  requestChangeUserPassword,
  requestConfirmUser,
  requestChangeUserAddress,
  requestGoogleLogin,
  requestGoogleCreate,
  requestAppendUser,
  requestReissuePassword,
  requestReissuePasswordOneTime,
  requestBuyRank,
  requestHasRegister,
  requestChangeLanguage,
  requestSetReferralCode,
  requestChangeCountry,
  requestDeleteIsUserRegister,
  requestSavedCard,
  requestDeleteCard,
  requestPointSavedCard,
  requestPaypalCreateOrder,
  requestPaypalCaptureOrder,
};
